export const MMS_GROUPED_SKU = 'MONSTERMASS'

export const MMS_BASE_UNIT_SKU = 'RF0720-BUNDLE'

export const MMS_CONFIG_SKU = 'RF0720-New'

export const MMS_ADDON_SKU = 'RF0721-BUNDLE'

export const MMS_4_PACK_WHEEL_SKU = 'RA1182'
export const MMS_2_PACK_WHEEL_SKU = 'RA1183'

export const MMS_SOLO_BOLT_KIT_SKU = 'RA0327-IL'
export const MMS_SHARED_BOLT_KIT_SKU = 'RA0461-IL'

export const MMS_CORNER_2_PACK_SKU = 'RF1074-2'
export const MMS_CORNER_3_PACK_SKU  = 'RF1074-3'
export const MMS_CORNER_4_PACK_SKU = 'RF1074-4'

export const MMS_GROUP_CHILD_SKUS = [MMS_BASE_UNIT_SKU, MMS_ADDON_SKU, MMS_SHARED_BOLT_KIT_SKU, MMS_SOLO_BOLT_KIT_SKU]

export const MMSUnit = [MMS_GROUPED_SKU, MMS_ADDON_SKU, MMS_BASE_UNIT_SKU]